// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiURL    : 'https://directoriopionero.espaciourbano.cl/api/',
  //apiURL    : 'https://espaciourbano-mobile-pionero.mzzo.com/api/',
   //apiURL    : 'http://localhost:8000/api/',
  edificio  : 161,
  totem     : 366,
  canal     : 2,
  idioma    : 'Esp',
  timereload : 0,
  tiendaimagen : false,
  idEst : [6610, 6611], /* IDs de estacionamientos */
  colorEst : ['Naranja', 'Verde'], /* colores estacionamientos*/
  listaTotems : [368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387],

  codCine: '0', /* id de Cine */
  patioDeComida: 0, /* id patio de comida, en caso de no haber usar 0 */
  zonaGourmet: 0, /* id zona gourmet, en caso de no haber usar 0 */
  restaurantes: [0],

  orientacionHor : [109,0], /* [Norte, Sur] */
  orientacionVer : [0, 0], /* [Oeste, Este] */

  tipoTransporte : {pie: 69, alternativo: 70},
  timeoutIdle : 45 /* cierre de sesion, en segundos */
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
